import { GROUPS } from '../const';
import { MODES } from '../components/drawer-contents/AssignmentsContentPanel/assignmentsContentPanelService';

const filterGroups = (resourceGroups, groups) =>
  resourceGroups.length
    ? groups.filter(group => resourceGroups.find(assignedGroup => group.id === assignedGroup))
    : groups;

const filterStudents = (resourceStudents, students) =>
  resourceStudents.length
    ? students.filter(student => resourceStudents.find(assignedStudent => student._id === assignedStudent))
    : students;

const getAvailableStudents = (groups, students) => {
  if (groups.length && groups[0].id !== 0) {
    const group = groups[0];
    return students.filter(student => {
      let isInGroup = false;
      if (student.groups) {
        student.groups.forEach(studentGroup => {
          if (studentGroup.id === group.id) {
            isInGroup = true;
          }
        });
      }
      return isInGroup;
    });
  }
  return students;
};

export const getCurrentConfiguration = (configuration, students) => {
  const lessonConfiguration = JSON.parse(JSON.stringify(GROUPS.EVERYONE));
  if (configuration) {
    if (configuration.groups && configuration.users) {
      if (configuration.users.length) {
        lessonConfiguration.isGroup = false;
        lessonConfiguration.isEveryone = false;
        lessonConfiguration.users = students.filter(student =>
          configuration.users.find(userId => userId === student._id)
        );
      } else if (configuration.groups.length) {
        lessonConfiguration.isGroup = true;
        lessonConfiguration.isEveryone = false;
        lessonConfiguration.id = configuration.groups[0];
      } else {
        lessonConfiguration.isGroup = true;
        lessonConfiguration.isEveryone = true;
      }
    }
  }
  return lessonConfiguration;
};

export const getAvailableGroupsAndUsers = (students, groups, selectedResource) => {
  if (selectedResource.isUnit) {
    if (selectedResource.bookAssign.groups.length) {
      const filteredGroups = filterGroups(selectedResource.bookAssign.groups, groups);
      const filteredStudents = getAvailableStudents(filteredGroups, students);
      return { availableGroups: filteredGroups, availableStudents: filteredStudents };
    } else if (selectedResource.bookAssign.users.length) {
      const filteredStudents = filterStudents(selectedResource.bookAssign.users, students);
      return { availableGroups: [], availableStudents: filteredStudents };
    }
  }
  if (selectedResource.isLesson) {
    if (selectedResource.unitAssign.groups.length) {
      const filteredGroups = filterGroups(selectedResource.unitAssign.groups, groups);
      const filteredStudents = getAvailableStudents(filteredGroups, students);
      return { availableGroups: filteredGroups, availableStudents: filteredStudents };
    } else if (selectedResource.unitAssign.users.length) {
      const filteredStudents = filterStudents(selectedResource.unitAssign.users, students);
      return { availableGroups: [], availableStudents: filteredStudents };
    } else if (selectedResource.bookAssign.groups.length) {
      const filteredGroups = filterGroups(selectedResource.bookAssign.groups, groups);
      const filteredStudents = getAvailableStudents(filteredGroups, students);
      return { availableGroups: filteredGroups, availableStudents: filteredStudents };
    } else if (selectedResource.bookAssign.users.length) {
      const filteredStudents = filterStudents(selectedResource.bookAssign.users, students);
      return { availableGroups: [], availableStudents: filteredStudents };
    }
  }
  return { availableGroups: groups, availableStudents: students };
};

export const fiterEditTaskUsers = (task, users, groupsData) => {
  let studentsTask = [];
  const groups = [];
  task.activities.map(act => {
    task.content.map(unit => {
      const activity = unit.auOrBlock.find(auOr => auOr.id === act.activityId);
      let exist = false;
      if (activity) {
        if (activity.configuration.users.length) {
          activity.configuration.users.map(userCheck => {
            exist = studentsTask.find(student => student._id === userCheck) || false;
            if (!exist) {
              studentsTask.push(users.find(user => user._id === userCheck));
            }
          });
        } else if (activity.configuration.groups.length) {
          activity.configuration.groups.map(groupCheck => {
            exist = studentsTask.find(student => student === groupCheck) || false;
            if (!exist) {
              groups.push(groupCheck);
            }
          });
        } else if (!activity.configuration.groups.length && !activity.configuration.users.length) {
          groups.push(0);
        } else {
          studentsTask = users;
        }
      }
    });
  });
  studentsTask = studentsTask.length === 0 ? getAllStudentsByContent(task.content, users, task.groups) : studentsTask;
  return { studentsTask, groups };
};

const getAllStudentsByContent = (content, allUsers, allGroups) => {
  const users = [];
  content.map(element => {
    if (element.configuration && element.configuration.users.length) {
      element.configuration.users.map(user => {
        const existUser = users.find(us => us._id === user._id || us._id === user);
        if (!existUser) users.push(allUsers.find(student => student._id === user));
      });
    } else if (element.configuration && element.configuration.groups.length) {
      element.configuration.groups.map(group => {
        const objectGroup = allGroups.find(gr => gr.id === group);
        objectGroup.participants.map(user => {
          const existUser = users.find(us => us._id === user._id);
          if (!existUser) users.push(allUsers.find(student => student._id === user));
        });
      });
    }
  });
  return users;
};

export const resolveContentTaskAssignment = (task, groups, isAppOnline, lessonsChecked) => {
  const selectGroup = { ...task.selectedGroup };
  const selectUsers = filterTaskUsers(groups, isAppOnline, lessonsChecked, task);
  const notBelong = [];
  let belong = [];
  let groupExist = true;

  if (!selectUsers.availableGroups.find(group => group.id === 0)) {
    if (selectUsers.availableStudents.length && !selectUsers.availableGroups.length) {
      const onlyIds = selectUsers.availableStudents.map(obj => obj._id);
      selectGroup.id = onlyIds;
      selectGroup.isEveryone = false;
      selectGroup.isGroup = false;
      const sourceIds =
        typeof task.selectedGroup.id === 'string' || typeof task.selectedGroup.id === 'number'
          ? (() => {
              const groupParticipants = task.groups.find(group => group.id === task.selectedGroup.id)?.participants;
              return (groupParticipants?.length > 0 ? groupParticipants : task.students).map(p => p._id || p);
            })()
          : task.selectedGroup.id;
      sourceIds.forEach(std => {
        const exists = selectUsers.availableStudents.find(student => student._id === std);
        if (!exists) {
          notBelong.push(task.students.find(student => student._id === std));
        } else {
          belong.push(std);
        }
      });
    } else if (!selectUsers.availableStudents.length && selectUsers.availableGroups.length) {
      if (task.selectedGroup.id !== 0) {
        const groupData = task.groups.find(group => group.id === task.selectedGroup.id);
        if (groupData) {
          const participants = groupData.participants.length > 0 ? groupData.participants : task.students;
          participants.forEach(participant => {
            const std = participant._id || participant;
            const exists = task.students.find(student => student === std);
            if (!exists) {
              notBelong.push(participants.find(student => student._id === std));
            } else {
              belong.push(std);
            }
          });
        } else {
          groupExist = false;
        }
      }
    } else if (selectUsers.availableStudents.length && selectUsers.availableGroups.length) {
      if (typeof task.selectedGroup.id === 'string' || typeof task.selectedGroup.id === 'number') {
        if (task.selectedGroup.id !== 0) {
          const availableGroup = selectUsers.availableGroups.find(group => group.id === task.selectedGroup.id);
          if (availableGroup) {
            const participants =
              availableGroup.participants.length > 0 ? availableGroup.participants : task.students;
            selectUsers.availableStudents.forEach(participant => {
              const std = participant._id || participant;
              const exists = participants.find(student => student === std);
              if (!exists) {
                notBelong.push(task.students.find(student => student._id === std));
              } else {
                belong.push(std);
              }
            });
          } else {
            groupExist = false;
          }
        } else {
          task.students.forEach(user => {
            const exists = selectUsers.availableStudents.find(student => student._id === user._id);
            if (!exists) {
              notBelong.push(task.students.find(student => student._id === user._id));
            } else {
              belong.push(user._id);
            }
          });
        }
      } else {
        task.selectedGroup.id.forEach(participant => {
          const exists = selectUsers.availableStudents.find(student => student._id === participant);
          if (!exists) {
            notBelong.push(task.students.find(student => student._id === participant));
          } else {
            belong.push(participant);
          }
        });
      }
    }
  } else if (Array.isArray(selectGroup.id)) {
    belong = selectGroup.id;
  } else if (selectGroup.id === 0) {
    task.students.forEach(std => belong.push(std._id));
  } else if (typeof selectGroup.id === 'string') {
    belong = task.groups.find(group => group.id === task.selectedGroup.id).participants;
  }

  return { selectGroup, belong, notBelong, groupExist };
};

export const filterTaskUsers = (groups, isAppOnline, lessons, task) => {
  const mode = isAppOnline ? MODES.CREATE : MODES.READ;
  const filteredUsers = {};
  filteredUsers.availableStudents = [];
  filteredUsers.availableGroups = [];
  let allStudents = false;
  if (mode === MODES.CREATE && task.activities !== null && task.activities.length) {
    const studentsTask = [];
    let groupsTask = [];
    task.activities.map(checked => {
      let lessonChecked = task.checkedActivities.find(chk => chk.indexOf(checked.activityId));
      if (!lessonChecked) {
        lessonChecked = task.checkedActivities.find(chk => chk === checked.activityId);
      }
      if (lessonChecked || !task.checkedActivities.length) {
        let unitAssign = null;
        task.book.content.map(act => {
          const lesson = act.content.find(l => l.activityId === lessonChecked);
          if (lessonChecked && act.fromCatalog && lessonChecked.indexOf(act.activityId) > -1) {
            unitAssign = act;
          } else if (lessonChecked && (!act.fromCatalog || (lesson && !lesson.fromCatalog))) {
            act.content.map(actCont => {
              if (checked.activityId.indexOf(actCont.activityId) > -1) {
                unitAssign = act;
              }
            });
          }
        });
        if (unitAssign) {
          task.book.content.map(unit => {
            unit.content.map(lesson => {
              const existLesson = Object.keys(lessons).find(less => less === lesson.activityId);
              if (existLesson) {
                if (!lesson.configuration.users.length && !lesson.configuration.groups.length) {
                  task.students.map(std => {
                    if (studentsTask.find(student => student._id === std._id) === undefined) {
                      studentsTask.push(task.students.find(student => student._id === std._id));
                    }
                  });
                  allStudents = true;
                  groupsTask = task.groups;
                } else if (lesson.configuration.users.length) {
                  lesson.configuration.users.map(user => {
                    if (studentsTask.find(student => student._id === user) === undefined) {
                      studentsTask.push(task.students.find(student => student._id === user));
                    }
                  });
                } else {
                  let participants = task.groups.find(group => group.id === lesson.configuration.groups[0]);
                  const existGroup = groupsTask.find(group => group.id === lesson.configuration.groups[0]);
                  if (!existGroup) {
                    groupsTask.push(participants);
                  }
                  if (participants && participants.participants.length) {
                    participants = task.groups.find(group => group.id === lesson.configuration.groups[0]).participants;
                    participants.map(part => {
                      if (studentsTask.find(student => student._id === part) === undefined) {
                        studentsTask.push(task.students.find(student => student._id === part));
                      }
                    });
                  }
                }
              }
            });
          });
          if (allStudents) {
            groupsTask = task.groups;
            filteredUsers.availableStudents = task.students;
            filteredUsers.availableGroups = groups;
            return filterStudents;
          }
          const { availableStudents, availableGroups } = getAvailableGroupsAndUsers(
            studentsTask,
            groupsTask,
            Object.assign(
              {
                isLesson: true,
                bookAssign: task.book.configuration,
                unitAssign: unitAssign.configuration
              },
              lessons
            )
          );
          availableStudents.map(fil => {
            const exist = filteredUsers.availableStudents.find(find => fil._id === find._id);
            if (exist === undefined) {
              filteredUsers.availableStudents.push(fil);
            }
          });
          availableGroups.map(fil => {
            const exist = filteredUsers.availableGroups.find(find => fil.id === find.id);
            if (exist === undefined) {
              if (fil.id === 0 && filteredUsers.availableGroups.length) {
                const firstElement = filteredUsers.availableGroups[0];
                filteredUsers.availableGroups[0] = fil;
                filteredUsers.availableGroups.push(firstElement);
              } else {
                filteredUsers.availableGroups.push(fil);
              }
            }
          });
        }
      }
    });
  } else {
    filteredUsers.availableStudents = task.students;
    filteredUsers.availableGroups = groups;
  }
  return filteredUsers;
};
